const title = document.querySelectorAll(".default__content .title");

title.forEach((item) => {
  !item.hasAttribute("data-title") &&
    item.setAttribute("data-title", item.textContent);
});
